import { useEffect, useRef } from 'react'
import { useI18n } from 'builder/hooks/useI18n'

import { useGetAddonPrice } from 'builder/hooks/useGetAddonPrice'
import { DialogModalV2 } from '../DialogModal'
import Button, { ButtonTheme } from '../Button'
import { useAutoApplyUpsellModal } from './useAutoApplyUpsellModal'
import {
  CardsContainer,
  Container,
  Details,
  DetailsContainer,
  PriceLoader,
  SlashedPrice,
  Title,
  Wrapper,
} from './styles'

import ApplySrc from './assets/apply.webp'
import ExpertSrc from './assets/expert.webp'
import HourGlassSrc from './assets/hour_glass.webp'
import TailoredSrc from './assets/tailored.webp'
import { Card } from './components/Card/Card'
import { List } from './components/List/List'
const TRANSLATION = 'builder.auto_apply.upsell_modal'

export const AutoApplyUpsellModal: React.FC = () => {
  const { i18n } = useI18n()
  const closeButtonRef = useRef<HTMLDivElement | null>(null)
  const { isOpen, handleCloseModal, handlePayment, planName } = useAutoApplyUpsellModal(true)

  const { upsellAmount, recurringAmount, isLoading } = useGetAddonPrice({
    addon: planName,
    fetchPrice: isOpen,
  })

  const getPriceButton = () => {
    if (isLoading)
      return (
        <>
          <div style={{ width: '10px' }} />
          <PriceLoader type="white" />
        </>
      )

    if (recurringAmount() === upsellAmount()) {
      return <>&nbsp;{upsellAmount()}</>
    }

    return (
      <>
        &nbsp;<SlashedPrice>{recurringAmount()}</SlashedPrice>&nbsp;{upsellAmount()}
      </>
    )
  }

  useEffect(() => {
    closeButtonRef.current?.scrollIntoView()
  }, [])

  if (!isOpen) return null

  return (
    <DialogModalV2
      disableAutoCloseOutside
      onClose={handleCloseModal}
      title={i18n.t(`${TRANSLATION}.title`)}
      subtitle={i18n.t(`${TRANSLATION}.description`)}
    >
      <Container>
        <Wrapper>
          <div>
            <Title>{i18n.t(`${TRANSLATION}.why_it_works`)}</Title>
            <CardsContainer>
              <Card
                imageSrc={TailoredSrc}
                text={i18n.t(`${TRANSLATION}.tailored_resume_for_each_job`)}
              />
              <Card
                imageSrc={ExpertSrc}
                text={i18n.t(`${TRANSLATION}.expert_reviewed_applications`)}
              />
              <Card
                imageSrc={HourGlassSrc}
                text={i18n.t(`${TRANSLATION}.reclaim_your_time_to_focus_on_interviews`)}
              />

              <Card
                imageSrc={ApplySrc}
                text={i18n.t(`${TRANSLATION}.apply_to_3x_more_jobs_with_less_effort`)}
              />
            </CardsContainer>
          </div>
          <div>
            <Title>{i18n.t(`${TRANSLATION}.how_it_works`)}</Title>
            <List
              items={[
                i18n.t(`${TRANSLATION}.pick_jobs_from_our`),
                i18n.t(`${TRANSLATION}.get_a_resume_cover_letter_with_job_specific_keywords`),
                i18n.t(`${TRANSLATION}.experts_submit_applications_for_you_error_free`),
                i18n.t(`${TRANSLATION}.track_all_applications_in_one_place`),
              ]}
            />
          </div>
          <Button theme={ButtonTheme.default} onClick={handlePayment}>
            {i18n.t(`${TRANSLATION}.button`)} {getPriceButton()}
          </Button>
        </Wrapper>
        <DetailsContainer>
          {isLoading ? (
            <PriceLoader />
          ) : (
            <Details
              dangerouslySetInnerHTML={{
                __html: i18n.t(`${TRANSLATION}.details`, { price: recurringAmount() }),
              }}
            />
          )}
        </DetailsContainer>
      </Container>
    </DialogModalV2>
  )
}
